import * as React from "react";
import ReactTable, { ReactTableColumn } from "../../ReactTable";
import local_settings, { FIELD_MUTATIONS_VIEW_LAST_MEASUREMENT } from "@/lib/localSettings";
import type { NumMutationsData } from "../types";

const columns: ReactTableColumn<MutationsRow>[] = [
    {
        accessor: "el_name",
        Header: "",
        filterInputPlaceholder: "Element name",
        disableFilters: false,
    },
    {
        accessor: "focus",
        Header: "Focus element",
        disableFilters: true,
        Cell: ({ value }) => {
            return (
                <button className="btn btn-primary" onClick={() => window.focusElement(value)}>
                    Focus
                </button>
            );
        },
    },
    {
        accessor: "ts",
        Header: "",
        disableFilters: true,
    },
];

const getHTMLElDescription = (el: HTMLElement | HTMLInputElement) => {
    return el.tagName + "." + el.className + "#" + el.id + "|name=" + (el as HTMLInputElement).name;
};

type MutationsRow = {
    original_ts: number;
    ts: string;
    el_name: string;
    focus: HTMLElement;
};

type Props = {};

export default class MutationsView extends React.Component<Props> {
    getNumOfMutations = (): NumMutationsData => {
        if (window.num_mutations) {
            return window.num_mutations;
        }
        return new Map();
    };

    getTableData = () => {
        let data: MutationsRow[] = [];
        for (const [ts, mutations] of this.getNumOfMutations().entries()) {
            for (const mutation of mutations) {
                const target = mutation.target as HTMLElement;
                data.push({
                    original_ts: ts,
                    ts: new Date(ts).toLocaleString(),
                    el_name: getHTMLElDescription(target),
                    focus: target,
                });
            }
        }

        data.sort((a: MutationsRow, b: MutationsRow) => a.original_ts - b.original_ts);

        let diff_sec = 0;
        if (data.length > 1) {
            diff_sec = (data[data.length - 1].original_ts - data[0].original_ts) / 1000;
        }

        local_settings.setItem(FIELD_MUTATIONS_VIEW_LAST_MEASUREMENT, diff_sec.toString());

        return {
            data,
            diff_sec,
        };
    };

    render() {
        const { data, diff_sec } = this.getTableData();
        return (
            <div className="num-renders-view">
                <div>Mutation time in seconds: {diff_sec}s</div>
                <ReactTable data={data} columns={columns} />
            </div>
        );
    }
}
